var _defs, _rect, _line, _line2, _text, _circle, _ellipse, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerFreeSpins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 170,
    viewBox: "0 0 220 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs-gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07A0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fs-coin",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE08A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8950C"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 42,
    width: 124,
    height: 86,
    rx: 16,
    fill: "#3A1605",
    fillOpacity: 0.5,
    stroke: "#FFB23D",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: 50,
    x2: 118,
    y2: 120,
    stroke: "#FFB23D",
    strokeOpacity: 0.18,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: 50,
    x2: 158,
    y2: 120,
    stroke: "#FFB23D",
    strokeOpacity: 0.18,
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 104,
    textAnchor: "middle",
    fontFamily: "'Arial Black','Arial',sans-serif",
    fontWeight: 900,
    fontStyle: "italic",
    fontSize: 60,
    fill: "url(#fs-gold)",
    stroke: "#7A3B00",
    strokeWidth: 1.2,
    strokeOpacity: 0.7
  }, "777")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 118,
    r: 15,
    fill: "url(#fs-coin)",
    stroke: "#B8730C",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 118,
    rx: 7,
    ry: 9,
    fill: "none",
    stroke: "#7A3B00",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 44,
    r: 9,
    fill: "url(#fs-coin)",
    stroke: "#B8730C",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 58,
    r: 7,
    fill: "url(#fs-coin)",
    stroke: "#B8730C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 64 l3 7 7 3 -7 3 -3 7 -3 -7 -7 -3 7 -3 z",
    fill: "#FFE9A8",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196 116 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2 z",
    fill: "#FFE9A8",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFreeSpins);
export default __webpack_public_path__ + "static/media/bannerFreeSpins.b3704f49b4d3f5f1fc479327e4ec814e.svg";
export { ForwardRef as ReactComponent };